import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  button: theme => ({
    alignSelf: 'center',
    backgroundColor: theme.colors.trayHandleButton,
    borderColor: theme.colors.trayHandleButton,
    borderRadius: 10,
    borderWidth: 2,
    height: 1,
    width: 37.4,
    zIndex: -1,
  }),
  dashStyle: {
    zIndex: 5,
  },
});
